<template>
    <div>
        <span class="key">{{name}}: </span>
        <a :href="link" target="_blank" class="value" :class="{expandable:!!callback||!!link,[type]:!!type}"
           @click="open">{{str(value)}}</a>
    </div>
</template>

<script>
    export default {
        props: {
            name: String,
            value: String | Number,
            link: String,
            type: String,
            callback: Function
        },
        methods: {
            open() {
                if (!!this.callback)
                    this.callback()
            },
            str(obj) {
                if (obj === null) {
                    return 'No';
                }
                if (typeof (obj) === typeof (false)) {
                    return obj ? 'Yes' : 'No';
                }

                return obj + '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .key {
        color: white;
        opacity: .7;
    }

    .value {
        color: rgba(255, 184, 0, 0.8);

        &.expandable {
            color: #fc0;
            cursor: pointer;
        }
        &.karma {
            color: #0c8;
        }

        &.comments {
            color: #fc0;
        }
    }
</style>
